import { makeAutoObservable } from 'mobx';

export interface SplitPanelConfig {
  id: string;
  size: number; // width or height percentage depending on orientation
}

export interface LayoutConfig {
  version: string;
  template: string;
  topPanels: SplitPanelConfig[]; // horizontal layout
  bottomHeight: number; // vertical layout height percentage for simulator panel
}

const DEFAULT_LAYOUT: LayoutConfig = {
  version: '1.1',
  template: 'VideoFocused',
  topPanels: [
    { id: 'map', size: 30 },
    { id: 'video', size: 40 },
    { id: 'controls', size: 30 }
  ],
  bottomHeight: 30
};

export class LayoutStore {
  layout: LayoutConfig = DEFAULT_LAYOUT;

  constructor() {
    makeAutoObservable(this);
    this.load();
  }

  setTopPanelSizes(prevIndex: number, nextIndex: number, prevSize: number, nextSize: number, save = false) {
    if (this.layout.topPanels[prevIndex]) {
      this.layout.topPanels[prevIndex].size = prevSize;
    }
    if (this.layout.topPanels[nextIndex]) {
      this.layout.topPanels[nextIndex].size = nextSize;
    }
    // Trigger MobX reactivity by reassigning the array
    this.layout.topPanels = [...this.layout.topPanels];
    if (save) {
      this.save();
    }
  }

  setBottomHeight(height: number) {
    this.layout.bottomHeight = height;
    this.save();
  }

  reset() {
    this.layout = JSON.parse(JSON.stringify(DEFAULT_LAYOUT));
    this.save();
  }

  load() {
    const data = localStorage.getItem('flightOpsLayout');
    if (data) {
      try {
        const parsed: LayoutConfig = JSON.parse(data);
        if (parsed && parsed.topPanels) {
          this.layout = parsed;
        }
      } catch {
        // ignore corrupt layouts
      }
    }
  }

  save() {
    localStorage.setItem('flightOpsLayout', JSON.stringify(this.layout));
  }
}

export const layoutStore = new LayoutStore();
